<template>
  <div id="app">
    <div class="view-body">
      <router-view />
    </div>
    <div class="footer">
      <div class="line"></div>
      <div class="footer-text">
        <el-link @click="handleLinkClick('PH20001')" :underline="false">私隱政策</el-link> | <el-link
          @click="handleLinkClick('PH20003')" :underline="false">
          一般條款及細則
        </el-link></br>
        版權屬香港青年協會所有Copyright © 2024
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'App',
    methods: {
      handleLinkClick(code) {
        this.$router.push({
          name: "ContentView",
          params: {
            code: code
          }
        });
      }
    }
  }

</script>

<style scoped>
  #app {
    font-family: 'IBM Plex Sans', 'Segoe UI', Arial, sans-serif !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;

  }

  .view-body {
    display: grid;
    place-items: center;
    /* 水平垂直居中 */
    /* height: 100vh; */
    /* 使用视口高度 */
  }

  .footer-text /deep/ .el-link.el-link--default {
    color: #2c3e50;
    font-size: 12px;
    text-decoration: underline;
  }

  .footer-text /deep/ .el-link.el-link--default:hover {
    color: #2c3e50;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue